import createList from '../../with-list';

import endpoints from '../../../../config/endpoints';

const namespace = 'blogArticleTagList';

const { actions, selectors, reducers } = createList({
	namespace,
	url: endpoints.BLOG.ARTICLE_TAGS,
	perPage: 50
});

export { namespace, actions, selectors, reducers as default };


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/blog/article-tag/list/index.js